import { createSlice } from "@reduxjs/toolkit";
import { AddRequisition, UpdateRequisition, GetRequisitions, GetRequisitionItems, GetRequisitionItemsForWorkOrder } from "services/requisition/requisition.service";
import { toast } from 'react-toastify';


export const requisitionListSlice = createSlice({
  name: "requisitionList",
  initialState: {
    requisitionList: [],
    requisitionListLoading: false,
    requisitionListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetRequisitions.pending, (state) => {
      state.requisitionListLoading = true
    });

    builder.addCase(GetRequisitions.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.requisitionList = action.payload
      state.requisitionListLoading = false
      state.requisitionListError = null
    });

    builder.addCase(GetRequisitions.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.requisitionListLoading = false
      state.requisitionListError = action.error?.message
    });
  },
});

export const requisitionAddSlice = createSlice({
  name: "requisitionAdd",
  initialState: {
    requisitionAdd: {},
    requisitionAddLoading: false,
    requisitionAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddRequisition.pending, (state) => {
      // toast.loading('We are adding the requisition 🤯')
      state.requisitionAddLoading = true
    });

    builder.addCase(AddRequisition.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New requisition added successfully 👌');

      state.requisitionAdd = action.payload
      state.requisitionAddLoading = false
      state.requisitionAddError = null
    });

    builder.addCase(AddRequisition.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the requisition 😣")

      state.requisitionAddLoading = false
      state.requisitionAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const requisitionUpdateSlice = createSlice({
  name: "requisitionUpdate",
  initialState: {
    requisitionUpdate: {},
    requisitionUpdateLoading: false,
    requisitionUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateRequisition.pending, (state) => {
      // toast.loading('We are updating the requisition 🤯')
      state.requisitionUpdateLoading = true
    });

    builder.addCase(UpdateRequisition.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Requisition update successfully 👌');

      state.requisitionUpdate = action.payload
      state.requisitionUpdateLoading = false
      state.requisitionUpdateError = null
    });

    builder.addCase(UpdateRequisition.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the requisition 😣")

      state.requisitionUpdateLoading = false
      state.requisitionUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const requisitionItemsSlice = createSlice({
  name: "requisitionItems",
  initialState: {
    requisitionItems: [],
    requisitionItemsLoading: false,
    requisitionItemsError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetRequisitionItems.pending, (state) => {
      state.requisitionItemsLoading = true
    });

    builder.addCase(GetRequisitionItems.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.requisitionItems = action.payload
      state.requisitionItemsLoading = false
      state.requisitionItemsError = null
    });

    builder.addCase(GetRequisitionItems.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.requisitionItemsLoading = false
      state.requisitionItemsError = action.error?.message
    });
  },
});


export const requisitionItemsForWorkOrderSlice = createSlice({
  name: "requisitionItemsForWorkOrder",
  initialState: {
    requisitionItemsForWorkOrder: [],
    requisitionItemsForWorkOrderLoading: false,
    requisitionItemsForWorkOrderError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetRequisitionItemsForWorkOrder.pending, (state) => {
      state.requisitionItemsForWorkOrderLoading = true
    });

    builder.addCase(GetRequisitionItemsForWorkOrder.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.requisitionItemsForWorkOrder = action.payload
      state.requisitionItemsForWorkOrderLoading = false
      state.requisitionItemsForWorkOrderError = null
    });

    builder.addCase(GetRequisitionItemsForWorkOrder.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.requisitionItemsForWorkOrderLoading = false
      state.requisitionItemsForWorkOrderError = action.error?.message
    });
  },
});